<template>
  <div class="UploadTable sadw15q4e">
    <el-dialog
      class="customDialog"
      title="添加数据源"
      :visible.sync="isShow"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="close"
    >
      <!-- 基本信息筛选 -->
      <div class="info">
        <p class="legend"><span>基本信息</span></p>
        <el-form
          ref="form"
          :model="ruleForm"
          :rules="rules"
          label-width="103px"
          size="mini"
          class="demo-ruleForm"
        >
          <el-form-item label="数据源类型：" prop="dataSourceType">
            <el-select
              @change="dataSourceTypeChange"
              v-model="ruleForm.dataSourceType"
              placeholder="请选择数据源类型"
            >
              <el-option label="EXCEL文件" value="EXCEL"></el-option>
              <el-option label="API接口" value="API"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="数据源名称：" prop="dataSourceName">
            <el-input v-model="ruleForm.dataSourceName" :maxlength="20" show-word-limit></el-input>
          </el-form-item>
          <el-form-item v-if="!excelShow" label="API列表：" prop="dataSource">
            <el-select
              @change="dataSourceChange"
              v-model="ruleForm.dataSource"
              placeholder="请选择数据源"
            >
              <el-option
                v-for="item in allApiData"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <!-- excel上传 -->
      <div v-if="excelShow" class="file">
        <p class="legend">
          <span>上传文件</span><span class="tip"> （文件大小不超过10M）</span>
        </p>
        <div class="uolpad">
          <el-upload
            class="upload-demo"
            :limit="1"
            action=""
            ref="excelUpload"
            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
            :show-file-list="true"
            :file-list="fileList"
            :auto-upload="false"
            :http-request="customUpload"
            :on-change="fileChange"
            :on-remove="fileListRemove"
          >
            <div class="fileHandler" id="excelId">
              <el-form
                :rules="rules"
                label-width="102px"
                size="mini"
                class="el-form"
              >
                <el-form-item label="上传文件：" prop="nameLabel">
                </el-form-item>
                <div class="submitBtn">
                  <img src="@/assets/images/upload.png" /><span
                    >上传EXCEL文件</span
                  >
                </div>
              </el-form>
            </div>
          </el-upload>
          <!-- 占位用 -->
          <div class="placeholder" v-if="openFile"></div>
          <span class="downLoad"
            ><i class="el-icon-download"></i>
            <a :href="baseurl + 'map/data/download/template'" download
              >数据模板下载</a
            ></span
          >
        </div>
      </div>
      <!-- 数据源键值 -->
      <div v-else class="keyName">
        <p class="legend"><span>数据源键值</span></p>

        <div class="api-container" v-if="keyValues.length > 0">
          <div class="item" v-for="item in keyValues" :key="item.key">
            <el-tooltip
              :content="item.key"
              placement="top-end"
              effect="light"
              :open-delay="1000"
              ><span>{{ item.key }}：</span></el-tooltip
            >
            <el-input
              maxlength="20"
              show-word-limit
              v-model="item.value"
              placeholder="请输入"
            ></el-input>
          </div>
        </div>

        <Empty v-else></Empty>
      </div>
      <!-- 操作按钮 -->
      <div class="handlerBtn">
        <el-button type="default" @click="close">取消</el-button>
        <el-button
          :loading="loading"
          type="primary"
          @click="submit(ruleForm.dataSourceType)"
          >确认</el-button
        >
      </div>
      <span slot="footer" class="dialog-footer"> </span>
    </el-dialog>
  </div>
</template>

<script>
import { upload, httpApi } from '@/api/dataManagement'
export default {
  name: 'Upload',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    // 数据源下拉列表
    allApiData: {
      type: Array,
      default: () => []
    }
  },
  components: {},
  data () {
    return {
      openFile: false,
      loading: false,
      excelShow: true,
      file: '',
      fileList: [],
      keyValues: [],
      dataSourceId: '',
      baseurl: process.env.VUE_APP_API_BASE_URL,
      ruleForm: {
        dataSourceType: 'EXCEL',
        dataSourceName: '',
        dataSource: ''
      },
      rules: {
        dataSourceType: [
          { required: true, message: '请选择数据源类型', trigger: 'change' }
        ],
        dataSourceName: [
          { required: true, message: '请输入数据源名称', trigger: 'blur' },
          {
            min: 0,
            max: 20,
            message: '长度在 1 到 20 个字符',
            trigger: 'blur'
          }
        ],
        dataSource: [
          { required: true, message: '请选择数据源', trigger: 'change' }
        ],
        nameLabel: [{ required: true }]
      },
      keyRules: {
        name: [
          { required: false },
          {
            min: 0,
            max: 20,
            message: '长度在 1 到 20 个字符',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  computed: {
    isShow: {
      get: function () {
        return this.show
      },
      set: function (v) {
        // 点击关闭按钮更新父组件传过来的参数为false
        this.$emit('update:show', v)
      }
    }
  },
  watch: {},
  mounted () {},
  methods: {
    dataSourceTypeChange (val) {
      if (val === 'EXCEL') {
        this.$nextTick(() => {
          this.openFile = false
          document.getElementById('excelId').style.opacity = 1
        })
      }
      this.$refs.form.clearValidate()
      this.ruleForm.dataSourceName = ''
      this.ruleForm.dataSource = ''
      this.keyValues = []
      this.file = ''
      this.fileList = []
      val === 'EXCEL' ? (this.excelShow = true) : (this.excelShow = false)
    },
    dataSourceChange (val) {
      this.keyValues = []
      this.allApiData.forEach((v) => {
        if (v.id === val) {
          this.dataSourceId = v.id
          v.keys.forEach((value) => {
            this.keyValues.push({
              key: value,
              value: ''
            })
          })
          v.alias.forEach((item) => {
            this.keyValues.forEach((keyItem) => {
              if (item.key === keyItem.key) {
                keyItem.value = item.name
              }
            })
          })
        }
      })
    },

    fileChange (file, fileList) {
      const types = [
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'application/vnd.ms-excel'
      ]
      const isExcel = types.includes(file.raw.type)
      const isLt10M = file.size / 1024 / 1024 < 10

      if (!isExcel) {
        this.$message.error('仅能上传 excel 文件!')
        this.$refs.excelUpload.clearFiles()
      } else if (!isLt10M) {
        this.$message.error('上传文件大小不能超过 10MB!')
        this.$refs.excelUpload.clearFiles()
      } else {
        this.openFile = true
        document.getElementById('excelId').style.opacity = 0.6
        if (this.ruleForm.dataSourceName.trim() === '') {
          this.ruleForm.dataSourceName =
            file.name.split('.')[0].length > 20
              ? file.name.split('.')[0].slice(0, 20)
              : file.name.split('.')[0]
        }
        file.status = 'success'
        this.file = file.raw
        this.fileList = fileList
        this.$refs.form.validate()
      }
    },
    fileListRemove (file, fileList) {
      // this.$refs.form.clearValidate()
      this.file = ''
      this.fileList = []
      const fileName =
        file.name.split('.')[0].length > 20
          ? file.name.split('.')[0].slice(0, 20)
          : file.name.split('.')[0]
      if (this.ruleForm.dataSourceName === fileName) {
        this.ruleForm.dataSourceName = ''
      }
      this.openFile = false
      document.getElementById('excelId').style.opacity = 1
    },
    // 文件自定义上传
    customUpload (file = this.file) {
      this.loading = true
      const formData = new FormData()
      formData.append('dataSourceType', 'EXCEL')
      formData.append('file', file)
      formData.append('name', this.ruleForm.dataSourceName.trim())
      // formData.append('name', encodeURIComponent(this.ruleForm.dataSourceName))
      upload(formData)
        .then((res) => {
          if (res.code === 200) {
            this.$emit('openDialog')
            this.$message.success('文件上传成功')
            this.loading = false
            this.isShow = false
          }
        })
        .catch(() => {
          this.loading = false
        })
    },
    // 编辑数据源键值别名
    editAlias () {
      this.loading = true
      const alias = []
      this.keyValues.forEach((v) => {
        alias.push({
          key: v.key,
          name: v.value
        })
      })
      const params = {
        dataSourceType: this.ruleForm.dataSourceType,
        httpApiConfig: {
          alias,
          id: this.dataSourceId
        },
        name: this.ruleForm.dataSourceName
      }
      httpApi(params)
        .then((res) => {
          if (res.code === 200) {
            this.$emit('openDialog')
            this.$message.success('设置成功!')
            this.loading = false
            this.isShow = false
          }
        })
        .catch(() => {
          this.loading = false
        })
    },
    close () {
      if (this.ruleForm.dataSourceType === 'EXCEL') {
        this.openFile = false
        if (document.getElementById('excelId')) {
          document.getElementById('excelId').style.opacity = 1
        }
      }
      this.$refs.form.resetFields()
      this.ruleForm = {
        dataSourceType: 'EXCEL',
        dataSourceName: '',
        dataSource: ''
      }
      this.file = ''
      this.fileList = []
      this.keyValues = []
      this.excelShow = true
      this.isShow = false
    },
    async submit (dataSourceType) {
      await this.$refs.form.validate()
      if (dataSourceType === 'EXCEL') {
        if (this.file === '' || this.fileList.length === 0) {
          this.$message.error('请选择excel文件')
        } else {
          this.customUpload()
        }
      }
      if (dataSourceType === 'API') {
        if (this.ruleForm.dataSourceName === '') {
          this.$message.error('请输入数据源名称')
        } else if (this.ruleForm.dataSource === '') {
          this.$message.error('请选择数据源')
        } else {
          this.editAlias()
        }
      }
    }
  },
  filters: {}
}
</script>

<style lang="scss">
.UploadTable.sadw15q4e {
  font-family: Source Han Sans SC;
  .customDialog {
    .el-dialog {
      width: 890px;
      .legend::before {
        content: "";
        width: 4px;
        height: 12px;
        background: #00a4f0;
        border-radius: 2px;
        margin-right: 8px;
      }
      .legend {
        display: flex;
        align-items: center;
        .tip {
          color: #999999;
        }
      }
      .el-form {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        padding: 0 26px;
        .el-input__inner {
          width: 260px;
          height: 32px;
        }
      }
      .info {
        border-bottom: 1px solid rgb(78, 78, 78);
        margin-bottom: 20px;
      }
    }
    .handlerBtn {
      text-align: right;
      button {
        width: 80px;
      }
      button + button {
        margin-left: 20px;
      }
    }
    .keyName {
      margin-bottom: 10px;
      .api-container {
        max-height: 400px;
        overflow: auto;
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-wrap: wrap;
        padding: 0 25px 0 23px;
        > .item {
          display: flex;
          align-items: center;
          justify-content: space-between;
          .el-tooltip {
            width: 102px;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            text-align: right;
            margin-right: 4px;
            color: #999;
          }
          .el-input {
            width: 260px;
          }
        }
        > .item {
          margin-top: 23px;
        }
        > .item:first-child,
        .item:nth-child(2) {
          margin-top: 0;
        }
      }
    }
  }
  .el-dialog__footer {
    display: none;
  }
  .el-dialog__body {
    text-align: left;
    border-radius: 6px;
    .uolpad {
      margin-bottom: 10px;
      position: relative;
      .fileHandler {
        .submitBtn {
          width: 164px;
          height: 32px;
          padding: 0 15px;
          background: rgba(0, 164, 240, 0.1);
          border: 1px dashed #00a4f0;
          border-radius: 6px;
          cursor: pointer;
          color: #00a4f0;
          display: flex;
          align-items: center;
          justify-content: space-around;
          img {
            width: 22px;
          }
        }
      }
      .placeholder {
        width: 318px;
        height: 50px;
        position: absolute;
        left: 0;
        top: 6px;
        cursor: not-allowed;
      }
      .el-upload-list {
        margin: 0 30px 0 128px;
      }
      .el-upload-list__item {
        background: rgba(0, 0, 0, 0.3);
        .el-upload-list__item-name {
          color: #fff;
        }
      }
      .el-upload-list__item:hover {
        background: rgba(0, 0, 0, 0.4);
      }
    }
    .upload-demo {
      transform: translateY(-10px);
    }
    .downLoad {
      font-size: 14px;
      cursor: pointer;
      // font-family: Source Han Sans SC;
      font-weight: 400;
      color: #00a4f0;
      position: absolute;
      right: 32px;
      top: 13px;
      a {
        text-decoration: none !important;
        color: #00a4f0;
      }
    }
    p {
      font-size: 14px;
      // font-family: Source Han Sans SC;
      font-weight: 400;
      color: #ffffff;
    }
  }

  .el-upload-list__item {
    height: 40px;
    line-height: 40px;
    border-radius: 6px;
    &:first-child {
      margin-top: 10px;
    }
    .el-icon-document:before {
      content: "";
      margin-left: 8px;
      transform: translateY(2px);
      width: 14px;
      height: 14px;
      display: block;
      background: url("../../../../assets/images/xls.png") no-repeat;
    }
    .el-icon-close {
      color: white;
      top: 14px;
    }
  }
  .el-form-item__label {
    padding: 0 !important;
  }
  .el-upload-list__item-status-label {
    right: 14px !important;
  }
  .el-icon-close {
    right: 14px !important;
  }
  .el-form-item--mini.el-form-item {
    margin-bottom: 22px;
  }
}
</style>
